import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
import highlight from 'flarum/common/helpers/highlight';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/components/Button';
import classList from 'flarum/common/utils/classList';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import humanTime from 'flarum/common/helpers/humanTime';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

export default class SendNoticeNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    return '#';
  }

  view(vnode) {
    const notification = this.attrs.notification;
    const href = this.href?.() ?? '';

    const fromUser = notification.fromUser();
  
    return (
      <Link
        className={classList('Notification', `Notification--${notification.contentType()}`, [!notification.isRead() && 'unread'])}
        href={href}
        external={href.includes('://')}
        onclick={this.markAsRead.bind(this)}
      >
        {fromUser && <Link href={fromUser ? app.route.user(fromUser) : '#'}>
          {avatar(fromUser || null)}
        </Link>}
        {this.img() && <img className="Notification-icon" src={this.img?.()}></img>}
        {icon(this.icon?.(), { className: 'Notification-icon' })}
        <span className="Notification-title">
          <span className="Notification-content">{this.content?.()}</span>
          <span className="Notification-title-spring" />
          {humanTime(notification.createdAt())}
        </span>
        {!notification.isRead() && (
          <Button
            className="Notification-action Button Button--link"
            icon="fas fa-check"
            title={app.translator.trans('core.forum.notifications.mark_as_read_tooltip')}
            onclick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              this.markAsRead();
            }}
          />
        )}
        <div className="Notification-excerpt">{this.excerpt?.()}</div>
      </Link>
    );
  }

  copyToClipboar(text){
    if (navigator.clipboard) { // 现代浏览器支持
      navigator.clipboard.writeText(text).then(function() {
        AlertUtil.onSuccess(app, app.translator.trans('dl-send.forum.copy_code'));
        // alert('内容已复制到剪贴板');
      }, function(err) {
        console.error('无法复制文本: ', err);
      });
    } else { // 兼容旧浏览器
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        AlertUtil.onSuccess(app, app.translator.trans('dl-send.forum.copy_code'));
        // alert('内容已复制到剪贴板');
      } catch (err) {
        console.error('无法复制文本: ', err);
      }
      document.body.removeChild(textArea);
    }
  }

  content() {
    const notification = this.attrs.notification;
    let myObject = notification.content();
    let titleText = notification.content().titleText;
  let selectText = notification.content().selectText;
    let contentText = notification.content().contentText;
    let pkgId = notification.content().pkgId;
    let pTagPattern = /<p[^>]*>|<\/p>/gi;
    contentText = highlight(contentText, selectText).children;
    let decodedText = contentText.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    contentText = decodedText.replace(pTagPattern, '');
    return <div className="split-container">
      <span className="titleText-row">{titleText}</span>
      <span className="contentText-row" onclick={() => this.copyToClipboar(selectText)}> {m.trust(contentText)}</span>
    </div>;

  }
}
